<template>
  <span class="duplicate-quote">
    <app-button
      v-if="showButton"
      :disabled="!allowDuplication"
      data-qa="duplicate-quote-button"
      @click="toggleDuplicateModal(true)"
      >{{ i18n.t('/DuplicateQuote/ButtonText') }}</app-button
    >

    <modal
      v-if="showDuplicateQuoteModal"
      :title="i18n.t('/DuplicateQuote/ModalTitle')"
      class="modal"
      @close="toggleDuplicateModal(false)"
    >
      <p>{{ i18n.t('/DuplicateQuote/InfoText') }}</p>

      <alert type="danger" :text="errorText" />

      <loader v-if="isLoading" />

      <app-button
        data-qa="duplicate-quote-confirm-button"
        :disabled="isLoading"
        @click="duplicateQuote(true)"
        >{{ i18n.t('/Common/Confirmation') }}</app-button
      >
      <app-button data-qa="duplicate-quote-cancel-button" @click="toggleDuplicateModal(false)">{{
        i18n.t('/Common/Cancel')
      }}</app-button>
    </modal>
  </span>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import quoteOrderService from '@/services/quoteOrderService'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import Alert from '@/components/generic/presentational/atoms/alert/Alert.vue'
import StoreConnector from '@/helpers/StoreConnector'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'

export default {
  components: {
    AppButton,
    Modal,
    Alert,
    Loader,
  },
  props: {
    showButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      orderService: quoteOrderService,
      showDuplicateQuoteModal: false,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      isLoading: false,
      allowDuplication: false,
      errorText: '',
      isSalesOrder: true,
    }
  },
  created() {
    StoreConnector.get('quote/hasCustomer', (data) => {
      this.allowDuplication = data
    })

    StoreConnector.get('quote/quoteStatusIsSalesOrder', (data) => {
      this.isSalesOrder = data
    })
  },
  methods: {
    async duplicateQuote() {
      this.isLoading = true
      try {
        // if the quote is not a salesorder, try to update it
        if (!this.isSalesOrder)
          await this.orderService.save({
            shouldUpdateEmployee: false,
            shouldUpdateEstablishment: false,
          })

        const resp = await this.orderService.duplicateQuote()
        this.toggleDuplicateModal(false)
        if (this.$router) {
          let params = {
            ...this.$route.params,
            quoteId: resp.data.QuoteId,
          }

          this.$router.push({ name: 'configuration-page', params, force: true })
        } else {
          // TODO: remove when b2c uses vue-router
          location.href = `${window.location.origin}/klantconfiguratie/${resp.data.QuoteId}`
        }
      } catch (e) {
        this.errorText = e.message
      } finally {
        this.isLoading = false
      }
    },
    toggleDuplicateModal(show) {
      if (!show) {
        this.errorText = ''
      }
      this.showDuplicateQuoteModal = show
    },
  },
}
</script>

<style lang="scss" scoped>
.duplicate-quote {
  margin-top: 12px;
  margin-right: 0.25em;
}
</style>
